import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
import { useState, useEffect } from "react";
import axios from "axios";
export default function Team() {
    const { t, i18n } = useTranslation();
    useScrollAnimation();

    const [dataTeam, setDataTeam] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const respons = await axios.get("https://laravel-api.alnujoud-jo.com/api/members");
                setDataTeam(respons.data.data)
            }
            catch (error) {
                console.error("Error When Fetch Data : ", error)
            }
        }
        fetchData();
    }, [])

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };

    const showData = dataTeam.map((el, index) =>
        <div key={index} className="w-100 w-[32%] shadow-[0px_0px_10px_#00000017] rounded-[8px]">
            <div className="w-full h-[300px]">
                <img className="w-[100%] h-[100%] border-b-[3px] border-[#017e89] rounded-t-[8px]" src={el.image} alt="" />
            </div>
            <div className="p-[20px] flex flex-col justify-between gap-[25px]">
                <div>
                    <div className="font-bold text-[#017E89] text-[20px] capitalize">
                        {t(getLocalizedText({ A: el.name_ar, E: el.name_en }))}
                    </div>
                    <div className="capitalize">
                        {t(getLocalizedText({ A: el.job_title_ar, E: el.job_title_en }))}
                    </div>
                </div>
                <Link
                    to={`/teamDetails/${el.id}`}>
                    <span className="capitalize font-bold">{t("view profile")}</span>
                    <img className="h-auto" src={require("../../assets/icons/twoLines.svg").default} alt="" />
                </Link>
            </div>
        </div>
    )
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("Our Team")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] fonbold">
                        <Link to={"/"}>{t("Home")}</Link>
                        -
                        <span className="text-[#017E89] capitalize">{t("Our Team")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="btmAni25002 flex items-baseline gap-[7px]">
                        <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                        <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("Our Team")}</div>
                    </div>
                    <div className="f-col w-full flex flex-wrap gap-[20px]">
                        {showData}
                    </div>
                </div>
            </section>
        </>
    );
}